import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { action, observable, runInAction } from 'mobx';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
import { InternalProductPricesLayer } from '../../transportLayers/data-cleaning/InternalProductPricesLayer';
/**
 * This store obtaining data cleaning category state - new
 */

export var InternalProductPricesStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(InternalProductPricesStore, _BaseStore);

  function InternalProductPricesStore() {
    var _this;

    _classCallCheck(this, InternalProductPricesStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InternalProductPricesStore).apply(this, arguments));
    _this.name = StoreName.InternalProductPrices;
    _this.internalProductPricesLayer = new InternalProductPricesLayer();
    _this.list = new Map();
    return _this;
  }

  _createClass(InternalProductPricesStore, [{
    key: "getInCategory",
    value: function getInCategory(categoryId) {
      var _this2 = this;

      this.list.clear();
      return this.internalProductPricesLayer.getInCategory(categoryId).then(function (InternalProductPricess) {
        runInAction(function () {
          InternalProductPricess.forEach(function (internalProductPrices) {
            _this2.list.set(internalProductPrices.internalProductId, internalProductPrices);
          });
        });
      });
    }
  }]);

  return InternalProductPricesStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Map)], InternalProductPricesStore.prototype, "list", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", Promise)], InternalProductPricesStore.prototype, "getInCategory", null);